const ky = require('ky').default;

const {
  TelemetryConfigurationNetworkError,
} = require('./logger/errors/telemetryConfigurationNetworkError');
const traceCreators = require('./logger/traceCreators');
const { Experiments } = require('./constants/Experiments');

const create = ({
  appLogger,
  fedopsLogger,
  baseUrl,
  metaSiteId,
  instance,
  essentials,
}) => {
  const SERVICE_ENDPOINT = `${baseUrl}/_api/wix-code-telemetry-registry-public/v1/sites/${metaSiteId}/telemetry`;
  const CONFIGURATION_URL = `${SERVICE_ENDPOINT}/runtime-configuration`;
  const PUBLIC_CONFIG_URL = `${baseUrl}/_api/wix-code-app-registry-global/v1/public-config`;
  const fallbackConfiguration = { hasSinks: false };

  const shouldUsePublicConfigEndpoint = essentials.experiments.enabled(
    Experiments.UsePublicConfigEndpoint,
  );

  const makeRequest = () =>
    ky
      .get(
        shouldUsePublicConfigEndpoint ? PUBLIC_CONFIG_URL : CONFIGURATION_URL,
        {
          headers: {
            Authorization: instance,
          },
        },
      )
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (shouldUsePublicConfigEndpoint) {
          return result?.public_config?.telemetry_data || fallbackConfiguration;
        }
        return result;
      });

  const fetchConfiguration = () => {
    const traceConfig = traceCreators.loadSiteMonitoringConfig();

    return appLogger
      .traceAsync(traceConfig, async () => {
        fedopsLogger.interactionStarted(traceConfig.actionName);
        const result = await makeRequest();
        fedopsLogger.interactionEnded(traceConfig.actionName);
        return result;
      })
      .catch((e) => {
        const url = shouldUsePublicConfigEndpoint ? PUBLIC_CONFIG_URL : CONFIGURATION_URL;
        appLogger.error(
          new TelemetryConfigurationNetworkError(e, url),
        );
        return fallbackConfiguration;
      });
  };

  return {
    fetchConfiguration,
  };
};

module.exports.create = create;
